'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ItemCount = require('./components/ItemCount.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemCount).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/item-count/index.js
// module id = 1300
// module chunks = 0